import { observable, action } from 'mobx'

class UploadStore {
    @observable public name: string = ''
    @observable public status: number = 0
    @observable public category: number = 0
    @observable public sensitivity: number = -1

    @observable public order: 'descend' | 'ascend' = 'descend'
    @observable public loading: boolean = false
    @observable public total: number = 0
    @observable public currentPage: number = 1
    @observable public pageSize: number = 10
    @observable public currentDataSource: any[] = []

    @observable public historyData: any[] = []
    @observable public loadingHistory: boolean = false

    @action
    public clear() {
        this.name = ''
        this.status = 0
        this.category = 0
        this.sensitivity = -1

        this.order = 'descend'
        this.loading = false
        this.total = 0
        this.currentPage = 1
        this.pageSize = 10
        this.currentDataSource = []
        this.historyData = []
        this.loadingHistory = false
    }

    @action
    public clearFilter() {
        this.name = ''
        this.status = 0
        this.category = 0
        this.sensitivity = -1
        this.order = 'descend'
    }

    public findIndex(id: number) {
        return this.currentDataSource.findIndex(item => item.id === id)
    }

    public get searchForm() {
        const formData: any = {}
        const name = this.name
        const status = this.status
        const category = this.category
        const sensitivity = this.sensitivity
        if (name) {
            if (name.trim() !== '') {
                formData.name = name.trim()
            }
        }
        if (status !== 0) {
            formData.status = status
        }
        if (category !== 0) {
            formData.category = category
        }
        if (sensitivity !== -1) {
            formData.sensitivity = sensitivity
        }
        formData.pageSize = this.pageSize
        formData.currentPage = this.currentPage
        formData.order = this.order
        return formData
    }

    @action
    public setName(value) {
        this.name = value
    }

    @action
    public setStatus(value: number | undefined) {
        if (value) {
            this.status = value
        } else {
            this.status = 0
        }
    }

    @action
    public setCategory(value: number | undefined) {
        if (value) {
            this.category = value
        } else {
            this.category = 0
        }
    }

    @action
    public setSensitivity(value) {
        if (value !== undefined) {
            this.sensitivity = value
        } else {
            this.sensitivity = -1
        }
    }
}

export default UploadStore
